import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {openAuthModal} from "../../auth/state/auth_modal_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {openVendorReportModal} from "../state/vendor_detail_slice";
import {hitGTMDeveloperReportClick} from "../tracking/hit_gtm_developer_report";

export function useVendorReportButton(vendorId: number) {
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();

    const handleClick = () => {
        hitGTMDeveloperReportClick();
        if (isUserAuthenticated) {
            dispatch(openVendorReportModal({vendorId}));
        } else {
            dispatch(
                openAuthModal({
                    userSource: UserSource.VENDOR_REPORT_BUTTON,
                    modalVariant: "download_report",
                    headerVariant: AuthModalVariant.DOWNLOAD_REPORT,
                    gtmSourceSection: "Rejestracja z przycisku pobrania raportu o deweloperze"
                })
            );
        }
    };

    return {
        handleClick,
        buttonText: isUserAuthenticated ? "Raport o deweloperze" : "Wygeneruj raport"
    };
}
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {openAuthModal} from "../../auth/state/auth_modal_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {openVendorReportModal} from "../state/vendor_detail_slice";
import {hitGTMDeveloperReportClick} from "../tracking/hit_gtm_developer_report";

export function useVendorReportButton(vendorId: number) {
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();

    const handleClick = () => {
        hitGTMDeveloperReportClick();
        if (isUserAuthenticated) {
            dispatch(openVendorReportModal({vendorId}));
        } else {
            dispatch(
                openAuthModal({
                    userSource: UserSource.VENDOR_REPORT_BUTTON,
                    modalVariant: "download_report",
                    headerVariant: AuthModalVariant.DOWNLOAD_REPORT,
                    gtmSourceSection: "Rejestracja z przycisku pobrania raportu o deweloperze"
                })
            );
        }
    };

    return {
        handleClick,
        buttonText: isUserAuthenticated ? "Raport o deweloperze" : "Wygeneruj raport"
    };
}
